// Reservations list
import { IPage, IPaging, IQueryParameters } from 'common/models';
import { removeFirstEmptyBracket as transformParams } from 'helper/strings';
import { IReservationListItem } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

interface IProps extends IPaging, IQueryParameters {}

export const getReservations = ({
  params,
  pageNo = 1,
  pageSize = 3,
}: IProps): Promise<IPage<IReservationListItem>> => {
  return API.get('/api/accommodation/calculations/list', {
    params: { pageSize, pageNo, ...params },
    paramsSerializer: parameters => transformParams(parameters),
  })?.then(response => response?.data);
};
